import React from "react";
import { Paper, Radio, Box, Typography } from "@mui/material";

interface ATSSelectionCardProps {
  value: string;
  title: string;
  description: string;
  selected: boolean;
  onSelect: (value: string) => void;
}

const ATSSelectionCard: React.FC<ATSSelectionCardProps> = ({
  value,
  title,
  description,
  selected,
  onSelect,
}) => (
  <Paper
    variant="outlined"
    onClick={() => onSelect(value)}
    sx={{
      display: "flex",
      alignItems: "center",
      p: 2,
      mb: 2,
      borderColor: selected ? "primary.main" : "divider",
      backgroundColor: selected ? "action.hover" : "background.paper",
      borderRadius: 2,
      cursor: "pointer",
      transition: "all 0.2s",
      "&:hover": { borderColor: "primary.main" },
    }}
  >
    <Radio value={value} checked={selected}/>
    <Box>
      <Typography variant="subtitle1" fontWeight={600}>
        {title}
      </Typography>
      <Typography color="text.secondary">{description}</Typography>
    </Box>
  </Paper>
);

export default ATSSelectionCard;
